/**
 * Subscription service — Stripe Payment Links resolved by the backend allowlist.
 * The frontend never builds or accepts an arbitrary payment URL:
 * POST /api/billing/payment-link validates the plan and returns the authorised link.
 */
import api from "@/lib/api";

const STRIPE_LINK_PREFIX = "https://buy.stripe.com/";

export async function getSubscribeUrl({ planId, user } = {}) {
  const r = await api.post("/billing/payment-link", {
    plan_id: planId || null,
    interval: (() => { try { return localStorage.getItem("athlynx_billing_interval") || "monthly"; } catch { return "monthly"; } })(),
  });
  if (r.data?.demo) return { demo: true, message: r.data.message };
  const url = r.data?.checkout_url;
  if (!url || !url.startsWith(STRIPE_LINK_PREFIX)) {
    throw new Error("Lien de paiement invalide");
  }
  const u = new URL(url);
  if (user?.user_id) u.searchParams.set("client_reference_id", user.user_id);
  if (user?.email) u.searchParams.set("prefilled_email", user.email);
  return { demo: false, url: u.toString() };
}

/** Redirect to Stripe. Returns { demo: true } in demo mode (no real payment). */
export async function startSubscribe({ planId, user, target = "same" } = {}) {
  const res = await getSubscribeUrl({ planId, user });
  if (res.demo) return res;
  if (target === "blank") {
    window.open(res.url, "_blank", "noopener,noreferrer");
  } else {
    window.location.assign(res.url);
  }
  return res;
}
